/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCountryDto } from '../../models/backend-country-dto';

export interface ProjectsCountriesList$Params {
  code?: string;
  currency?: number;
  name?: string;
  name_en?: string;
  prefix?: string;

  /**
   * A search term.
   */
  search?: string;
}

export function projectsCountriesList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsCountriesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCountryDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsCountriesList.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('currency', params.currency, {});
    rb.query('name', params.name, {});
    rb.query('name_en', params.name_en, {});
    rb.query('prefix', params.prefix, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCountryDto>>;
    }),
  );
}

projectsCountriesList.PATH = '/api/projects/countries/';
